var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgFavDefaultWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-bb9813d7-deeb-48be-b091-fdb83d2a3b7a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 39.47,
    y1: 54.53,
    x2: 62.02,
    y2: 54.53,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.74,
    y1: 65.8,
    x2: 50.74,
    y2: 43.25,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.06,91.25c-2.63-1.92,5.18-29.89,5.18-29.89,0,0-21.69-20.15-21.69-21.21s30.03-4.31,30.03-4.31c0,0,12.01-27.19,13.47-27.18,1.46,0,13.38,27.23,13.38,27.23,0,0,30.02,3.4,30.02,4.41s-21.76,21.14-21.76,21.14c0,0,5.98,29.25,5.08,29.91s-26.83-14.16-26.83-14.16c0,0-25.04,15.42-26.88,14.07h0Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgFavDefaultWhite);
export default __webpack_public_path__ + "static/media/SvgFavDefaultWhite.547dfbc5ae14ad4407971f2220bf5400.svg";
export { ForwardRef as ReactComponent };